module.exports = "/packs/images/homepage/facilities/childrens_centres_mobile~ed0e0eb6080eb3e6296115beae359406.jpg";